import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import type { WeatherForecastData } from "./use-weather-forecast.types";

export type { WeatherDay, WeatherForecastData } from "./use-weather-forecast.types";

export function useWeatherForecast(
  start?: string,
  end?: string,
  options?: { enabled?: boolean },
) {
  return useQuery<WeatherForecastData>({
    queryKey: ["weatherForecast", start, end],
    queryFn: () => api.getWeather(start, end),
    enabled: options?.enabled ?? true,
    staleTime: 3 * 60 * 60 * 1000, // 3 hours — match backend cache TTL
    refetchOnWindowFocus: false,
  });
}
